import { render, staticRenderFns } from "./StudentManager.vue?vue&type=template&id=4bd3f311&scoped=true"
import script from "./StudentManager.vue?vue&type=script&lang=js"
export * from "./StudentManager.vue?vue&type=script&lang=js"
import style0 from "./StudentManager.vue?vue&type=style&index=0&id=4bd3f311&prod&scoped=true&lang=css"
import style1 from "./StudentManager.vue?vue&type=style&index=1&id=4bd3f311&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3f311",
  null
  
)

export default component.exports